import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Token } from '../models/token.model';
import { ApiV2Service } from './api-v2.service';
import { User } from '../models/user.model';
import { Organization } from '../interfaces/organization-info.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private currentTokenSubject: BehaviorSubject<Token>;
  public currentTokenValue: Observable<Token>;

  private currentUserSubject: BehaviorSubject<User>;
  public currentUserValue: Observable<User>;

  private currentOrganizationsSubject: BehaviorSubject<Organization[]>;
  public currentOrganizationsValue: Observable<Organization[]>;

  private currentMainOrganizationSubject: BehaviorSubject<Organization>;
  public currentMainOrganizationValue: Observable<Organization>;

  constructor(private http: HttpClient, private router: Router, private api: ApiV2Service) {
    this.currentTokenSubject = new BehaviorSubject<Token>(JSON.parse(localStorage.getItem('token')));
    this.currentTokenValue = this.currentTokenSubject.asObservable();
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
    this.currentUserValue = this.currentUserSubject.asObservable();
    this.currentOrganizationsSubject = new BehaviorSubject<Organization[]>(JSON.parse(localStorage.getItem('organizations')));
    this.currentOrganizationsValue = this.currentOrganizationsSubject.asObservable();
    this.currentMainOrganizationSubject = new BehaviorSubject<Organization>(JSON.parse(localStorage.getItem('mainOrganization')));
    this.currentMainOrganizationValue = this.currentMainOrganizationSubject.asObservable();
  }

  public setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  public getToken(): string {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token && token.key) {
      return token.key;
    } else {
      return null;
    }
  }

  public get currentToken(): Token {
    return this.currentTokenSubject.value;
  }

  public get currentUser(): User {
    return this.currentUserSubject.value;
  }
  public set currentUser(user: User) {
    this.currentUserSubject.next(user);
   localStorage.setItem('user', JSON.stringify(user)); }

  public get currentOrganizations(): Organization[] {
    return this.currentOrganizationsSubject.value;
  }

  public get currentMainOrganization(): Organization {
    return this.currentMainOrganizationSubject.value
  }

  public get isLoggeIn(): boolean {
    const hasToken = this.currentTokenSubject.value && this.currentTokenSubject.value.key;
    const hasUser = this.currentUserSubject.value && this.currentUserSubject.value.organizations && (this.currentUserSubject.value.organizations.length > 0);
    return (hasToken && hasUser) ? true : false;
  }

  public set isLoggeIn(state) {}

  login(username: string, password: string) {
    console.log('Iniciando sesión');
    const body: any = {
      email: username,
      password: password
    };
    return this.http.post<Token>(`${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2.LOGIN}`, body).pipe(map(token => {
      if (token.key) {
        localStorage.setItem('token', JSON.stringify(token));
        this.currentTokenSubject.next(token);
        this.init();
        return token;
      } else {
        this.currentTokenSubject.next(null);
        return null;
      }
    }));
  }

  login2(username: string, password: string) {
    console.log('Iniciando sesión');
    const body: any = {
      email: username,
      password: password
    };
    return this.http.post<Token>(`${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2.LOGIN}`, body).pipe(map(token => {
      if (token.key) {
        localStorage.setItem('token', JSON.stringify(token));
        this.currentTokenSubject.next(token);
        return token;
      } else {
        this.currentTokenSubject.next(null);
        return null;
      }
    }));
  }

  logout() {
    console.log('cerrar sessión');
    // remove user from local storage to log user out
    this.isLoggeIn = false;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('organizations');
    localStorage.removeItem('mainOrganization');
    localStorage.removeItem('courses');
    localStorage.removeItem('categories');
    this.currentTokenSubject.next(null);
    this.currentUserSubject.next(null);
    this.currentOrganizationsSubject.next(null);
    this.currentMainOrganizationSubject.next(null);
    // this.currentCoursesSubject.next(null);
    setTimeout(() => {
      this.router.navigate(['/auth/login']);
      location.reload()
    }, 100);
  }

  forgot() {
    console.log('recuperar contraseña');
  }

  signup(body: any) {
    console.log('crear usuario');
    return this.http.post<Token>(`${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2.SIGNUP}`, body).pipe(map(token => {
      if (token.key) {
        localStorage.setItem('token', JSON.stringify(token));
        this.currentTokenSubject.next(token);
        this.init();
        return token;
      } else {
        this.currentTokenSubject.next(null);
        return null;
      }
    }));
  }
  
  teacherSignup(body: any) {
    console.log('crear usuario_particular');
    return this.http.post<Token>(`${environment.apiUrlBase}${environment.endpoints.v2.PREFIX}${environment.endpoints.v2.SIGNUP}`, body).pipe(map(token => {
      if (token.key) {
        localStorage.setItem('token', JSON.stringify(token));
        this.currentTokenSubject.next(token);
        return token;
      } else {
        this.currentTokenSubject.next(null);
        return null;
      }
    }));
  }

  // Carga de condiciones iniciales luego de hacer login
  init() {
    this.getUserSession();
    //    this.getCategories();
  }

  getUserSession() {
    this.api.getService('GET_USER_SESSION')
      .pipe(map(data => {
        if (data['organizations']) {
          data['isOrgAdmin'] = data['is_org_admin'];
          data['isSuperuser'] = data['is_superuser'];
          delete data['is_org_admin'];
          delete data['is_superuser'];
          for (const k in data['organizations']) {
            data['organizations'][k]['organizationType'] = data['organizations'][k]['organization_type'];
            delete data['organizations'][k]['organization_type'];
          }
          return data;
        } else {
          data['isOrgAdmin'] = data['is_org_admin'];
          data['isSuperuser'] = data['is_superuser'];
          delete data['is_org_admin'];
          delete data['is_superuser'];
          return data;
        }
      }))
      .subscribe(
        (user: User) => {
          if (user) {
            // this.user = user[0];
            this.currentUserSubject.next(user);
            localStorage.setItem('user', JSON.stringify(user));
            this.getOrganizations(user.organizations);
          } else {
            console.log('Hubo un error con la información del usuario');
          }
          // console.log('Usuario:', user);
        },
        (error) => {
          this.currentUserSubject.next(null);
          localStorage.removeItem('user');
          this.currentOrganizationsSubject.next(null);
          localStorage.removeItem('organizations');
          console.log('Error:', error);
        }
      );
  }

  getOrganizations(organizations: Organization[]) {
    if (organizations && organizations.length > 0) {
      this.currentOrganizationsSubject.next(organizations);
      localStorage.setItem('organizations', JSON.stringify(organizations));
      this.setMainOrganization(organizations);
      // this.getCoursesByOrganizations(organizations);
    } else {
      console.log('No pertenece a una organización');
    }
  }

  setMainOrganization(organizations: Organization[]) {
    const familyOrg: Organization = organizations.filter((item: Organization) => item.organizationType === "Familia")[0];
    const schoolOrg: Organization = organizations.filter((item: Organization) => item.organizationType === "Escuela")[0];
    let mainOrg: Organization = {};
    if(familyOrg) {
      mainOrg = familyOrg;
    } else if(schoolOrg) {
      mainOrg = schoolOrg;
    } else {
      mainOrg = organizations[0];
    }
    this.currentMainOrganizationSubject.next(mainOrg);
    localStorage.setItem('mainOrganization', JSON.stringify(mainOrg));
  }


}
